module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec_bg_3-8a85cc641481b2a6fa3de21e43aa5b39.svg";